import { JwtPayload } from "jwt-decode";

export interface CustomJwtPayload extends JwtPayload {
  roles?: string[];
}

export interface IReportList {
  JobEliminationTrackingSummary: boolean;
  WARNEstimate: boolean;
  IntakeFormSummaryReport: boolean;
  IntakeFormDetailReport: boolean;
  NonUSImpactedEmployeeDetailReport: boolean;
  IntakeFormToolSecurityReport: boolean;
  CombinedImpactedEmployeeDetailReport: boolean;
  CompareGroupDetailReport: boolean;
  HRAssistReport: boolean;
  PendingDataChangesReport: boolean;
  CompareGroupSummaryReport: boolean;
  CountryHRDIntakeSummaryReport: boolean;
  ImpactedEmployeeDetailReport: boolean;
}
// Default IUserRoles object with all properties set to false
export const defaultUserRoles: IUserRoles = {
  SATAdmin: false,
  ReportUser: false,
  IFTSATAdmin: false,
  IntakeAdmin: false,
  SeveranceAdmin: false,
  IntakeUser: false,
  JobEliminationTrackingSummary: false,
  WARNEstimate: false,
  IntakeFormSummaryReport: false,
  IntakeFormDetailReport: false,
  NonUSImpactedEmployeeDetailReport: false,
  IntakeFormToolSecurityReport: false,
  CombinedImpactedEmployeeDetailReport: false,
  CompareGroupDetailReport: false,
  HRAssistReport: false,
  PendingDataChangesReport: false,
  CompareGroupSummaryReport: false,
  CountryHRDIntakeSummaryReport: false,
  ImpactedEmployeeDetailReport: false,
};

export interface IUserRoles extends IReportList {
  SATAdmin: boolean;
  ReportUser: boolean;
  IFTSATAdmin: boolean;
  IntakeAdmin: boolean;
  SeveranceAdmin: boolean;
  IntakeUser: boolean;
}
